<script>
/**
 * "Send to assistant": what the person wants done with the email. Resolves with
 * the text (a pick or what they typed), or null on cancel.
 */
export default {
  name: 'message-assistant-ask',

  props: {
    subject: {type: String, default: ''},
  },

  data() {
    return {
      text: '',
      picks: ['Draft a reply', 'Make a quote', 'Make a sales order', 'Make a PO from the invoice', 'Summarize it and tell me what to do'],
    }
  },

  mounted() {
    this.$nextTick(() => this.$refs.input && this.$refs.input.focus())
  },

  methods: {
    send(text) {
      this.$root.$emit('submit', String(text ?? this.text).trim() || 'Draft a reply')
    },
  },
}
</script>

<template>
  <modal title="Send to Assistant" height="auto">
    <template #footer>
      <b-button size="sm" variant="outline-secondary" class="mr-2" @click="$root.$emit('submit', null)">Cancel</b-button>
      <b-button size="sm" variant="primary" class="px-4" @click="send()">Send</b-button>
    </template>

    <div class="mx-2 my-2">
      <div class="small text-muted mb-2" v-if="subject">{{ subject }}</div>
      <label for="assistant-ask" class="font-weight-bold">What do you need help with?</label>
      <div class="d-flex flex-wrap mb-2">
        <b-button v-for="p in picks" :key="p" size="sm" variant="outline-primary" class="mr-2 mb-2" @click="send(p)">{{ p }}</b-button>
      </div>
      <b-textarea id="assistant-ask" ref="input" v-model="text" rows="3" placeholder="Or say it in your own words - e.g. quote 2 of these to them with UPS Ground"
                  @keydown.enter.exact.prevent="send()"/>
      <div class="small text-muted mt-1">The assistant reads the email, its attachments and the AI notes first. Nothing is sent or saved until you say so in the chat.</div>
    </div>
  </modal>
</template>
